/**
 * widgets/registry.gitlab.tsx — GitLab widgety.
 *
 * 3 custom widgety (kind: 'custom' = kompozitní, obsahují modaly/forms → data si
 * tahá komponenta sama). Kombinují se do `GITLAB_PANEL` v `module-panels.ts`.
 */
import { Cpu, FolderKanban, GitBranch, GitMerge, Server, Users, Wrench } from 'lucide-react';
import type { WidgetSpec } from './types';
import { InstancesPanel } from '../pages/modules/gitlab/InstancesPanel';
import { ProjectsPanel } from '../pages/modules/gitlab/ProjectsPanel';
import { RunnersPanel } from '../pages/modules/gitlab/RunnersPanel';
import { ServersPanel } from '../pages/modules/gitlab/ServersPanel';
import { MaintenancePanel } from '../pages/modules/gitlab/MaintenancePanel';
import { UsersPanel } from '../pages/modules/gitlab/UsersPanel';
import { GroupsPanel } from '../pages/modules/gitlab/GroupsPanel';

export const GITLAB_WIDGETS: WidgetSpec[] = [
  {
    id: 'gitlab.instances',
    title: 'GitLab instance',
    module: 'gitlab',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: GitMerge,
    component: InstancesPanel,
  },
  {
    id: 'gitlab.runners',
    title: 'Workery (GitLab / GitHub)',
    module: 'gitlab',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Cpu,
    component: RunnersPanel,
  },
  {
    id: 'gitlab.projects',
    title: 'Připojené projekty',
    module: 'gitlab',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: GitBranch,
    component: ProjectsPanel,
  },
  {
    id: 'gitlab.groups',
    title: 'Skupiny GitLabu',
    module: 'gitlab',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: FolderKanban,
    component: GroupsPanel,
  },
  {
    id: 'gitlab.users',
    title: 'Uživatelé GitLabu',
    module: 'gitlab',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Users,
    component: UsersPanel,
  },
  {
    id: 'gitlab.maintenance',
    title: 'Údržba a nastavení',
    module: 'gitlab',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Wrench,
    component: MaintenancePanel,
  },
  {
    id: 'gitlab.servers',
    title: 'GitLab servery',
    module: 'gitlab',
    kind: 'custom',
    format: 'md',
    formats: ['sm', 'md', 'lg'],
    icon: Server,
    component: ServersPanel,
  },
];
